import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';

import { COLORS } from '@theme/colors';

export const Container = styled.div`
  position: relative;
`;

export const List = styled(motion.ul)`
  margin: 0;
  padding: 0;
  list-style: none;
  position: absolute;
  top: 34px;
  transition: all 0.2s ease-in-out;
  padding-top: 3px;
  width: 300px;
`;

export const Item = styled(motion.li)`
  padding: 8px 0px;
`;

export const Link = styled.a`
  background: ${COLORS.WHITE};
  padding: 5.5px 8px;

  &:hover {
    color ${COLORS.GUARDSMAN_RED};
  }
`;

export const Trigger = styled.a<{ isOpen: boolean; isActive: boolean }>`
  padding: 9px 8px;
  display: flex;
  z-index: 2;
  position: relative;

  ${({ isOpen, isActive }) =>
    (isOpen || isActive) &&
    css`
      background: ${COLORS.WHITE};
    `}

  &:hover {
    color ${COLORS.GUARDSMAN_RED};
  }
`;
